<template>
	<div class="selectChange">
		<el-select v-model="value" placeholder="请选择" filterable size="small" @change="change" >
			<el-option
				v-for="item in tableData.options"
				:key="item[tableData.props.value]"
				:label="item[tableData.props.label]"
				:value="item[tableData.props.value]"
			>
			</el-option>
		</el-select>
	</div>
</template>

<script>
export default {
	name: 'selectChange',
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		return {
			value: '',
			options: [
				{
					value: '选项1',
					label: '黄金糕',
				},
				{
					value: '选项2',
					label: '双皮奶',
				},
				{
					value: '选项3',
					label: '蚵仔煎',
				},
				{
					value: '选项4',
					label: '龙须面',
				},
				{
					value: '选项5',
					label: '北京烤鸭',
				},
			],
		};
	},
	watch: {
		'scope.row': {
			handler() {
				this.value = this.scope.row[this.tableData.bind];
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		// 选择器选择时
		change(val) {
			let { scope, tableData } = this;
			tableData.change && tableData.change(val, scope.row, tableData);
		},
	},
};
</script>

<style lang="scss" scoped>
.selectChange {
}
</style>
